import { useEffect, useState } from "react";
import { Check, Minus } from "lucide-react";
import { api } from "@/lib/api";
import { startLogin, useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

const COLS = [["event_subscriber", "Hub event subscriber"], ["hub_member", "Hub Member"], ["incubatee", "Incubatee"]];

export default function WestmontPublic() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/public/westmont").then(({ data }) => setD(data));
  }, []);
  return (
    <div className="mx-auto max-w-5xl px-4 py-16 sm:px-6 lg:px-8" data-testid="westmont-public-page">
      <p className="caption text-[#0D9488]">Westmont Enterprise Hub</p>
      <h1 className="mt-3 text-4xl font-bold text-[#0B192C] sm:text-5xl">A route into the Hub</h1>
      <p className="mt-4 max-w-3xl text-slate-600">Organise your business information, understand your protection and funding options, prepare your next steps and ask for the right support. The Westmont Enterprise Hub at the University of West London reviews every membership and incubation application itself.</p>
      <div className="mt-8">{user ? <Link to="/app/westmont" className="btn-teal" data-testid="westmont-public-start">Choose your route</Link> : <button onClick={startLogin} className="btn-teal" data-testid="westmont-public-start">Sign in to choose your route</button>}</div>
      <section className="card mt-10 overflow-x-auto p-6" data-testid="benefit-matrix">
        <h2 className="font-semibold text-[#0B192C]">What each membership category includes</h2>
        <table className="mt-4 w-full min-w-[640px] text-sm">
          <thead><tr className="text-left text-xs text-slate-500"><th className="py-2">Benefit</th>{COLS.map(([, l]) => <th key={l}>{l}</th>)}<th>Delivered by</th><th>Availability</th></tr></thead>
          <tbody>{(d?.benefits || []).map((b) => (
            <tr key={b.name} className="border-t border-slate-100"><td className="py-2.5 font-medium">{b.name}</td>
              {COLS.map(([k]) => <td key={k}>{b.categories.includes(k) ? <Check className="h-4 w-4 text-[#1F8A8B]" aria-label="Included" /> : <Minus className="h-4 w-4 text-slate-300" aria-label="Not included" />}</td>)}
              <td className="text-xs text-slate-600">{b.owner}</td><td className="text-xs text-amber-800">{b.availability}</td></tr>))}</tbody>
        </table>
        <p className="mt-4 text-xs text-slate-500">These benefits don't include unrestricted lab access, free consultancy, guaranteed introductions, funding, or university endorsement of a business. Official fees and separately quoted professional work are always extra. Members need specific written agreement before using any university or Hub marks.</p>
      </section>
    </div>
  );
}
